// A API entrega instantes em UTC (timestamptz). A exibicao e fixada em
// Brasilia de proposito: sem o timeZone explicito, toLocaleString usa o fuso
// da maquina de quem acessa, e a mesma aprovacao apareceria com horarios
// diferentes para pessoas em fusos diferentes.
const TIME_ZONE = 'America/Sao_Paulo';

export function formatDateTime(value) {
  if (!value) return '';
  return new Date(value).toLocaleString('pt-BR', { timeZone: TIME_ZONE });
}

export function formatDate(value) {
  if (!value) return '';
  return new Date(value).toLocaleDateString('pt-BR', { timeZone: TIME_ZONE });
}

export { TIME_ZONE };
